export default __webpack_public_path__ + "static/media/logo_clubs.ded11189.svg";